import Config from "./vueconfig.js";
/**
 * environment
 * @function getAppId
 * @function getAppName
 * @function getApiUrl
 * @function getApiModuleUrl
 * @function getBlobUrl
 * @function getMiscUrl
 * @function getShoppingCartUrl
 * @function getApiShoppingCartUrl
 * @function getApi
 * @function isDebugMode
 * api config str
 * @function getCampaignConfig
 * @function getDashboardConfig
 * @function getCategoryConfig
 * @function getHistoryConfig
 * setting
 * @function getCacheType
 * @function getAddressType
 * @function getFirebaseSetup
 * @function getEncryptSetting
 * custom
 * @function getCampaignListDevApp
 * @function getCategoryMenuDev
 */
export default class ConfigManager {

    //#region normal environment
    static getAppId() {
        return Config().app_id;
    }
    static getAppName() {
        return Config().appname;
    }
    static getApiUrl() {
        return Config().bzbsUrl;
    }
    static getApiModuleUrl() {
        return Config().bzbsModuleUrl;
    }
    static getBlobUrl() {
        return Config().bzbsBlobUrl;
    }
    static getMiscUrl() {
        return Config().miscUrl;
    }
    static getShoppingCartUrl() {
        return Config().webShoppingCartUrl;
    }
    static getApiShoppingCartUrl() {
        return Config().apiShoppingCartUrl;
    }
    static getApi() {
        return Config().api;
    }
    static isDebugMode() {
        return Config().debug;
    }
    static getRecaptchaSiteKey() {
        return Config().recaptchaSiteKey;
    }
    static getSubscriptionKey() {
        return Config().subscription_key;
    }
    //#endregion normal environment

    //#region config str
    static getCampaignConfig() {
        return Config().campaignConfig;
    }
    static getDashboardConfig() {
        return Config().dashboardConfig;
    }
    static getCategoryConfig() {
        return Config().categoryConfig;
    }
    static getHistoryConfig() {
        return Config().historyConfig;
    }
    static getCouponConfig() {
        return Config().couponConfig;
    }
    //#endregion config str

    //#region setting
    static getCacheType() {
        return Config().setting.cache;
    }
    static getAddressType() {
        return Config().setting.addressType;
    }
    static getFirebaseSetup() {
        return Config().firebase;
    }
    static getEncryptSetting() {
        return Config().setting.encryptAccount;
    }
    static getWebApiUrl() {
        return Config().webApi
    }
    //#endregion setting

    //#region custom
    static getCampaignListDevApp() {
        return this.getCampaignConfig().campaignListConfig;
    }
    static getCategoryMenuDev() {
        return this.getCategoryConfig().menuCategory;
    }
    static getHistoryPurchaseList() {
        return this.getHistoryConfig().purchase;
    }
    static getCouponConfigList() {
        return this.getCouponConfig().coupon;
    }
    //#endregion custom
}
